import { useAuth } from "../../hooks";
import OwnerHome from "./OwnerHome";
import SellerHome from "./SellerHome";

const DashboardRouter = () => {
  const { user } = useAuth();

  if (user?.role === "seller") {
    return <SellerHome />;
  }

  return <OwnerHome />;
};

export default DashboardRouter;
